// Libraries
import React, { useState, useMemo } from 'react'
import {
   Paper,
   Typography,
   Accordion,
   AccordionSummary,
   AccordionDetails,
   TablePagination
} from '@material-ui/core'

// Components
import MaterialIcon from 'components/materialIcon/materialIcon'

// Icons
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

// Styles
import useErrorsTableStyles from './styles'

const PageSize = 5

function ErrorsTable({ tableData = {} }) {
   const classes = useErrorsTableStyles()

   const [currentPage, setCurrentPage] = useState(0)

   const currentTableData = useMemo(() => {
      const firstPageIndex = currentPage * PageSize
      const lastPageIndex = firstPageIndex + PageSize
      return tableData.data.slice(firstPageIndex, lastPageIndex)
   }, [currentPage])

   return (
      <Paper className={classes.tableContainer}>
         <div className={classes.tableHeader}>
            <Typography className={classes.tableTitle}>
               {`Errores en la carga del archivo ${tableData.fileName}`}
            </Typography>
         </div>
         <div className={classes.tableBody}>
            {currentTableData.map(wrongLine => {
               const { lineNumber, arrayOfErrorTexts } = wrongLine
               return (
                  <Accordion key={lineNumber}>
                     <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        className={classes.accordeonItemHeader}
                     >
                        <Typography>{`Registro ${lineNumber}`}</Typography>
                     </AccordionSummary>
                     <AccordionDetails>
                        <div>
                           {arrayOfErrorTexts.map(errorText => (
                              <div className={classes.errorTextContainer}>
                                 <MaterialIcon
                                    fill="outlined"
                                    name={'error_outlined'}
                                    size={18}
                                    extraClass={classes.errorIcon}
                                 />
                                 <div>{errorText}</div>
                              </div>
                           ))}
                        </div>
                     </AccordionDetails>
                  </Accordion>
               )
            })}
         </div>
         <div className={classes.tableFooter}>
            <TablePagination
               classes={{ root: classes.pagination }}
               rowsPerPage={PageSize}
               count={tableData.data.length}
               page={currentPage}
               onChangePage={(_, page) => setCurrentPage(page)}
               onChangeRowsPerPage={() => {}}
               rowsPerPageOptions={[PageSize]}
            />
         </div>
      </Paper>
   )
}

export default ErrorsTable
